import { Component } from '@combos-fun/engine';
import { Transform2D } from '@combos-fun/plugin-renderer';
import Matter from 'matter-js';

export enum PhysicsType {
  RECTANGLE = 'rectangle',
  CIRCLE = 'circle',
  POLYGON = 'polygon',
  TRAPEZOID = 'trapezoid',
  FROM_VERTICES = 'fromVertices',
  CAPSULE = 'capsule',
  COMPOUND = 'compound',
  EDGE = 'edge',
  CHAIN = 'chain',
}

export interface PhysicsVertex {
  x: number
  y: number
}

export interface PhysicsBodyOptions {
  isStatic?: boolean,
  restitution?: number,
  density?: number,
  [propName: string]: any,
}

/** One piece of a `COMPOUND` body. Nested `COMPOUND` is not allowed. */
export interface PhysicsPartParams {
  type: PhysicsType
  bodyOptions?: PhysicsBodyOptions
  position?: {
    x?: number
    y?: number
  }
  sides?: number
  radius?: number
  width?: number
  height?: number
  slope?: number
  vertices?: PhysicsVertex[]
  vertexSets?: PhysicsVertex[][]
  length?: number
  from?: PhysicsVertex
  to?: PhysicsVertex
  thickness?: number
}

export interface PhysicsParams {
  type?: PhysicsType
  bodyOptions?: PhysicsBodyOptions
  position?: {
    x?: number
    y?: number
  }
  sides?: number
  radius?: number
  stopRotation?: boolean
  width?: number
  height?: number
  slope?: number
  vertices?: PhysicsVertex[]
  vertexSets?: PhysicsVertex[][]
  length?: number
  from?: PhysicsVertex
  to?: PhysicsVertex
  thickness?: number
  parts?: PhysicsPartParams[]
}

export class Physics extends Component<PhysicsParams> {
  static componentName: string = 'Physics';
  public bodyParams: PhysicsParams;
  public body: Matter.Body;
  private PhysicsEngine: Matter.Engine;

  init(params: PhysicsParams) {
    this.bodyParams = params;
  }

  update() {
    if (this.body && this.gameObject) {
      const transform = this.gameObject.getComponent(Transform2D);
      if (!transform) return;
      transform.anchor.x = 0;
      transform.anchor.y = 0;
      transform.position.x = this.body.position.x;
      transform.position.y = this.body.position.y;
      if (!this.bodyParams.stopRotation) {
        transform.rotation = this.body.angle;
      }
    }
  }
  onDestroy() {
    Matter.World.remove(this.PhysicsEngine.world, this.body, true);
  }
}
